export default "__VITE_ASSET__cYOPiWOQ__"